import React, {useContext} from 'react';
import {DispatchContext} from '../../../store';
import {taskPoolServices} from '../../../services/TaskPoolServices';
import {catalogueTransition} from '../../../services/CatalogueServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});
export default function AcceptDeaccession(props) {
  const dispatch = useContext(DispatchContext);
  const {open, handleAction, roleId, taskPool} = props;

  const poolId = taskPool?.map(value => value?.role_id);

  const isRoleIdInPool = poolId.includes(roleId);

  let taskPoolId = null;

  if (isRoleIdInPool) {
    const index = poolId.indexOf(roleId);

    if (index !== -1) {
      taskPoolId = taskPool[index]?.id;
    }
  }

  const onSubmit = async () => {
    taskPoolServices('put', taskPoolId, {action: 'approve'}).then(response => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Deaccession approved successfully'}
      });
      handleAction();
    });
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAction}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle align={'center'} color={'#616B88'} sx={{fontSize: 25}} className={'text-bold'}
                     fontWeight={700}>
          Approve Deaccession
        </DialogTitle>
        <Box className={'common-divider'}/>
        <DialogContent sx={{width: 400}}>
          <Typography>
            Are you sure you want to accept this deaccession? By confirming, you acknowledge that you have reviewed and
            agree to the terms and contents of this deaccession.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAction} variant={'outlined'}
                  color={'error'} className={'text-capitalize'}>
            Cancel
          </Button>
          <Button variant={'contained'} onClick={onSubmit} className={'text-capitalize'}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}